import axios from "axios";
import {URLSERVICIOS} from "../Constantes";

export const enviarPeticion = async ({datos, flujo}) => {

    const url = `${URLSERVICIOS}proxy.php`;

    datos.flujo = flujo;

    try {

        const respuesta = await axios.post(url, datos, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return respuesta.data

    } catch (error) {
        if (error.response) {
            // El servidor respondió con un código de estado fuera del rango 2xx
            console.error('Error HTTP:', error.response.status, error.response.data);
        } else if (error.request) {
            // La petición fue hecha pero no se recibió respuesta
            console.error('Sin respuesta del servidor:', error.request);
        } else {
            console.error('Error al configurar la petición:', error.message);
        }
    }
}